import React, { Component } from 'react'
import Icon from 'svg-inline-react'
import Modal from 'components/shared/Modal'

import './style.styl'

import ROCK_ON_ICON from '!svg-inline?removeTags=true!images/svg/rockon.svg'
import CLOSE_ICON from '!svg-inline?removeTags=true!images/icons/times-icon.svg'
import AGENT_STATUS_SRC from './images/agentstatus.png'
import SNOOZE_SRC from './images/snooze.png'
import RULES_SRC from './images/rule.png'

class OptInModal extends Component {

  constructor(props) {
    super(props)
    
    this.state = {
      position: 0,
      active: 0
    }
  }

  changePosition(index) {
    this.setState({ 
      position: index * 500, 
      active: index 
    })
  }

  render() {
    const { onClose } = this.props
    return (
      //get rid of this opinionated modal wrapper...
      //and these inline reset styles..
      <Modal
        onRequestClose={onClose}
        isOpen={true}
        style={{ content: { padding: 0, border: '1px solid transparent', background: 'none' }}}
      >
        <div className="drift-modal gradient-modal opt-in-modal">
          <header>
            <Icon src={ROCK_ON_ICON} />
            <h2>Update Successful!</h2>            
          </header>

          <div className="drift-image-slider" style={ { transform: `translateX(-${this.state.position}px)` } }>
            <div className="drift-image-slider-slide">

              <div className="drift-image-slider-slide-image">
                <img src={AGENT_STATUS_SRC} />
              </div>
              <strong>Agent Availability is now only Active + Away </strong>
              <p>We simplified Agent Availability. When you set yourself to Away, you won’t be automatically added to conversations. Perfect for when you need to step out for lunch!</p>
            </div>

            <div className="drift-image-slider-slide">

              <div className="drift-image-slider-slide-image">
                <img src={SNOOZE_SRC} />
              </div>
              <strong>You can now snooze notifications even if you’re Active</strong>
              <p>Do Not Disturb is now a notification toggle so you can control whether or not you recieve notifications seperately from your Active or Away status.</p>
            </div>

            <div className="drift-image-slider-slide">

              <div className="drift-image-slider-slide-image">
                <img src={RULES_SRC} />
              </div>
              <strong>On-Call is <span>replaced</span> by the Default Lead Routing Rule</strong>
              <p>We’ll be turning the On-Call status into a Default Lead Routing Rule to reduce confusion and give you more control over who is automatically added to a conversation.</p>
            </div>
          </div>

          <div className="drift-image-slider-pager">
            {
              _.range(3).map(index => (
                <span 
                  className={ (index === this.state.active) && 'active'} 
                  onClick={ () => this.changePosition(index) }/> 
              ))
            }
          </div>


        </div>
      </Modal>
    )
  }
}

export default OptInModal



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/layouts/OptInModal/index.js